/* OKKO B2B — shell dashboard: sidebar di navigazione.
   Lo stato "ridotta" (solo icone) vive su <html> e in localStorage: uno script
   inline in theme.liquid lo riapplica PRIMA del paint, senza flash al load.
   Su mobile la stessa sidebar diventa off-canvas (hamburger in testata + velo). */
(() => {
  const CHIAVE = 'okko-nav-ridotta';

  // Altezza del blocco sticky del catalogo -> CSS var per lo sticky della sidebar
  // filtri. Ri-misurata a ogni variazione di layout osservando <html>: cosi'
  // sopravvive anche allo swap AJAX che sostituisce l'intero blocco.
  const misuraCatalogTop = () => {
    const el = document.querySelector('[data-okko-catalog-top]');
    document.documentElement.style.setProperty('--okko-catalog-top-h', el ? el.offsetHeight + 'px' : '0px');
    // Tabella piu' larga del suo spazio? Torna lo scroll orizzontale interno
    // (e la thead smette di essere sticky — vedi okko-b2b.css). scrollWidth
    // conta l'overflow anche con overflow:visible, quindi il check regge in
    // entrambi i modi e in entrambe le direzioni di resize.
    const wrap = document.querySelector('.okko-table-wrap');
    if (wrap) wrap.classList.toggle('is-scrollx', wrap.scrollWidth > wrap.clientWidth + 1);
  };
  if ('ResizeObserver' in window) new ResizeObserver(misuraCatalogTop).observe(document.documentElement);
  window.addEventListener('load', misuraCatalogTop);

  // Altezza della fascia sticky in cima -> --okko-testata-h. Era una costante
  // (56px, 109 sul mobile) scritta a mano nel CSS, e bastava aggiungere una
  // sezione nell'header-group perche' tutto cio' che ci si ancora - sidebar,
  // drawer, sticky del catalogo, PDP, ancore - restasse indietro della stessa
  // misura: con una barra annunci da 38px la sidebar finiva sotto la testata.
  // Ora si misura la fascia vera. Il CSS tiene il suo valore come partenza, per
  // il pre-paint e per il caso senza JS.
  // Nota: si misura il WRAPPER, e la barra dentro ha una variabile sua
  // (--okko-testata-barra-h). Se leggesse questa, misurarla la farebbe crescere
  // a ogni giro dell'osservatore.
  const misuraTestata = () => {
    const fascia = document.querySelector('.okko-app__testata');
    if (!fascia) return;
    const h = Math.round(fascia.getBoundingClientRect().height);
    if (h > 0) document.documentElement.style.setProperty('--okko-testata-h', h + 'px');
  };
  if ('ResizeObserver' in window) {
    const fascia = document.querySelector('.okko-app__testata');
    if (fascia) new ResizeObserver(misuraTestata).observe(fascia);
  }
  window.addEventListener('load', misuraTestata);
  misuraTestata();

  // Il bottone di riduzione e' un interruttore: a barra ridotta APRE, quindi
  // title e tooltip devono dirlo. Lo stato e' riapplicato prima del paint
  // dallo script inline in theme.liquid, percio' si allinea anche al load.
  function allineaRiduci() {
    const btn = document.querySelector('[data-okko-nav-riduci]');
    if (!btn) return;
    const chiuso = document.documentElement.classList.contains('okko-nav-ridotta');
    const apri = btn.dataset.okkoTipRidotta;
    const riduci = btn.querySelector('.okko-nav__etichetta')?.textContent.trim();
    const nome = chiuso ? apri : riduci;
    if (nome) btn.setAttribute('title', nome);
  }
  allineaRiduci();

  // AUTO-riduzione sotto i 1220px, stesso criterio del pre-paint in theme.liquid
  // (secondo gradino della cascata catalogo: prima i filtri off-canvas a 1500).
  // Sotto la soglia la riduzione e' FORZATA (una vecchia preferenza '0' terrebbe
  // la barra estesa proprio dove lo spazio manca; il bottone riapre comunque al
  // volo). Sopra, comanda la preferenza salvata.
  const mqNavAuto = window.matchMedia('(max-width: 1220px)');
  mqNavAuto.addEventListener('change', () => {
    let pref = null;
    try { pref = localStorage.getItem(CHIAVE); } catch (err) { /* noop */ }
    document.documentElement.classList.toggle('okko-nav-ridotta', mqNavAuto.matches || pref === '1');
    allineaRiduci();
  });

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-okko-nav-riduci]')) {
      const ridotta = document.documentElement.classList.toggle('okko-nav-ridotta');
      try { localStorage.setItem(CHIAVE, ridotta ? '1' : '0'); } catch (err) { /* storage pieno/negato: lo stato resta solo di sessione */ }
      allineaRiduci();
      return;
    }
    if (e.target.closest('[data-okko-nav-apri]')) {
      document.documentElement.classList.toggle('okko-nav-aperta');
      return;
    }
    if (e.target.closest('[data-okko-nav-velo]')) {
      document.documentElement.classList.remove('okko-nav-aperta');
      return;
    }
    // Filtri off-canvas (<=1280px): stessa meccanica della nav, classe su
    // <html> cosi' il pannello resta aperto attraverso gli swap AJAX
    // (v. anche in coda: nell'editor selezionare uno Strumento apre la modale)
    if (e.target.closest('[data-okko-filtri-apri]')) {
      document.documentElement.classList.toggle('okko-filtri-aperti');
      return;
    }
    if (e.target.closest('[data-okko-filtri-velo]')) {
      document.documentElement.classList.remove('okko-filtri-aperti');
      return;
    }
    // Nascondi/mostra prezzi: classe su <html> + cookie di sessione, cosi' lo
    // stato sopravvive alla navigazione (riapplicato pre-paint da theme.liquid)
    const prezzi = e.target.closest('[data-okko-prezzi-toggle]');
    if (prezzi) {
      const nascosti = document.documentElement.classList.toggle('okko-prezzi-nascosti');
      document.cookie = nascosti
        ? 'okko_nascondi_prezzi=1; path=/; SameSite=Lax'
        : 'okko_nascondi_prezzi=; path=/; Max-Age=0; SameSite=Lax';
      allineaTitle(prezzi);
    }
  });

  // --- Sidebar che scorre ------------------------------------------------------
  // Su monitor bassi l'area delle voci scorre, e gli Strumenti in fondo restano
  // nascosti sopra "Riduci menu" senza nessun segno che ci siano. Due classi
  // sulla sidebar dicono se c'e' altro sopra o sotto: il CSS ci mette la
  // sfumatura, e sotto anche la freccina che porta in fondo. Si ricalcola allo
  // scroll, al resize e quando cambia l'altezza del contenuto (fisarmoniche del
  // megamenu nel drawer, sezioni ricaricate nell'editor).
  const navScroll = document.querySelector('.okko-nav__scroll');
  const navBox = navScroll?.closest('.okko-nav');
  if (navBox) {
    const giu = document.createElement('button');
    giu.type = 'button';
    giu.className = 'okko-nav__giu';
    // scorciatoia per il mouse: da tastiera la sidebar scorre gia' seguendo il fuoco
    giu.tabIndex = -1;
    giu.setAttribute('aria-hidden', 'true');
    giu.innerHTML = '<svg viewBox="0 0 24 24"><path d="M6 9l6 6 6-6"/></svg>';
    giu.addEventListener('click', () => navScroll.scrollTo({ top: navScroll.scrollHeight, behavior: 'smooth' }));
    navBox.appendChild(giu);

    const segnaScorrimento = () => {
      const sotto = navScroll.scrollHeight - navScroll.clientHeight - navScroll.scrollTop;
      navBox.classList.toggle('is-altro-sopra', navScroll.scrollTop > 2);
      navBox.classList.toggle('is-altro-sotto', sotto > 2);
      navBox.style.setProperty('--okko-nav-sb', `${navScroll.offsetWidth - navScroll.clientWidth}px`);
    };
    navScroll.addEventListener('scroll', segnaScorrimento, { passive: true });
    window.addEventListener('resize', segnaScorrimento);
    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(segnaScorrimento);
      const osserva = () => {
        ro.disconnect();
        ro.observe(navScroll);
        [...navScroll.children].forEach((el) => ro.observe(el));
      };
      osserva();
      document.addEventListener('shopify:section:load', osserva);
    }
    segnaScorrimento();
  }

  // --- Editor del tema: selezionare uno Strumento apre la sua modale ---------
  // Gli eventi shopify:section:* esistono solo nell'anteprima dell'editor.
  // QO/Salvati/Bozza si aprono col loro flusso normale (click sintetico sul
  // trigger: il contenuto e' montato dal rispettivo JS); Ordini e' gia'
  // server-rendered e basta lo showModal.

  function clickSintetico(attr) {
    const b = document.createElement('button');
    b.setAttribute(attr, '');
    b.hidden = true;
    document.body.appendChild(b);
    b.click();
    b.remove();
  }

  document.addEventListener('shopify:section:select', (e) => {
    const dlg = e.target.querySelector(
      'dialog[data-okko-qo-modal], dialog[data-okko-salvati-modal], dialog[data-okko-bozza-modal], dialog[data-okko-ordini-modal], dialog[data-okko-promo-modal], dialog[data-okko-piuord-modal]'
    );
    if (!dlg) return;
    if (dlg.hasAttribute('data-okko-qo-modal')) clickSintetico('data-okko-quickorder-open');
    else if (dlg.hasAttribute('data-okko-salvati-modal')) clickSintetico('data-okko-wishlist-open');
    else if (dlg.hasAttribute('data-okko-bozza-modal')) clickSintetico('data-okko-draft-open');
    else if (!dlg.open) dlg.showModal();
  });

  // --- Tooltip delle voci a sidebar RIDOTTA ----------------------------------
  // Un solo elemento condiviso in position:fixed appeso al body: dentro la
  // sidebar verrebbe tagliato da .okko-nav__scroll (overflow: hidden auto).
  // Il testo esce dall'etichetta gia' nel markup (niente stringhe duplicate);
  // il `title` nativo viene tolto durante l'hover e rimesso all'uscita, cosi'
  // resta il nome accessibile della voce senza doppio tooltip.
  const TIP_MIN = 901; // la riduzione e' solo desktop
  let tip = null;
  let vocaConTitle = null;

  const ridotta = () => document.documentElement.classList.contains('okko-nav-ridotta')
    && window.innerWidth >= TIP_MIN;

  /**
   * Testo dell'etichetta ATTIVA: le voci a due stati (Nascondi/Mostra prezzi)
   * ne hanno due nel markup e il CSS ne spegne una. Prendere la prima darebbe
   * sempre "Nascondi prezzi", anche a prezzi gia' nascosti.
   */
  function etichettaVisibile(voce) {
    const spans = [...voce.querySelectorAll('.okko-nav__etichetta')];
    const viva = spans.find((el) => getComputedStyle(el).display !== 'none');
    return (viva || spans[0])?.textContent.trim() || '';
  }

  /** Allinea il title (nome accessibile) all'etichetta attiva. */
  function allineaTitle(voce) {
    const testo = etichettaVisibile(voce);
    if (!testo) return;
    if (voce.dataset.okkoTitle !== undefined) voce.dataset.okkoTitle = testo; // hover in corso
    else voce.setAttribute('title', testo);
  }

  /**
   * Apre il tooltip condiviso accanto a un elemento qualsiasi. Di norma a
   * destra; se uscirebbe dallo schermo si ribalta a sinistra (le colonne di
   * destra delle tabelle sono vicine al bordo).
   */
  function apriTip(anchor, testo) {
    if (!testo) return;
    if (!tip) {
      tip = document.createElement('div');
      tip.className = 'okko-tip';
      tip.setAttribute('role', 'tooltip');
      document.body.appendChild(tip);
    }
    // Dentro una modale (showModal) il body sta SOTTO il top layer: il tip va
    // riagganciato al dialog che contiene l'ancora, o non si vede. Il fixed
    // resta viewport-relative (le modali non hanno transform).
    const host = anchor.closest('dialog') || document.body;
    if (tip.parentNode !== host) host.appendChild(tip);
    tip.textContent = testo;
    tip.classList.remove('is-sinistra', 'is-sopra');
    tip.classList.add('is-on');

    const r = anchor.getBoundingClientRect();
    const misura = tip.getBoundingClientRect();
    const largo = misura.width;
    if (anchor.dataset.okkoTipPos === 'sopra') {
      // SOPRA l'ancora, centrato (opt-in via data-okko-tip-pos: il bottone
      // Avvisami sta nell'ultima colonna utile e di lato coprirebbe la riga).
      // Clamp ai bordi: la freccetta resta centrata sull'ancora comunque.
      tip.classList.add('is-sopra');
      let sx = Math.round(r.left + r.width / 2 - largo / 2);
      sx = Math.max(8, Math.min(sx, window.innerWidth - 8 - largo));
      tip.style.left = `${sx}px`;
      tip.style.top = `${Math.round(r.top - 8 - misura.height)}px`;
    } else {
      const sbordo = r.right + 10 + largo > window.innerWidth - 8;
      if (sbordo) {
        tip.classList.add('is-sinistra');
        tip.style.left = `${Math.round(r.left - 10 - largo)}px`;
      } else {
        tip.style.left = `${Math.round(r.right + 10)}px`;
      }
      tip.style.top = `${Math.round(r.top + r.height / 2)}px`;
    }

    // niente tooltip nativo sopra il nostro
    if (anchor.hasAttribute('title')) {
      vocaConTitle = anchor;
      anchor.dataset.okkoTitle = anchor.getAttribute('title');
      anchor.removeAttribute('title');
    }
  }

  function mostraTip(voce) {
    // data-okko-tip-ridotta: testo valido SOLO a barra ridotta (il bottone
    // "Riduci menu" li' apre, quindi il tooltip dice "Apri menu")
    apriTip(voce, voce.dataset.okkoTipRidotta || etichettaVisibile(voce) || voce.getAttribute('title') || '');
  }

  function nascondiTip() {
    if (tip) tip.classList.remove('is-on');
    if (vocaConTitle) {
      vocaConTitle.setAttribute('title', vocaConTitle.dataset.okkoTitle || '');
      delete vocaConTitle.dataset.okkoTitle;
      vocaConTitle = null;
      // il click sul bottone di riduzione cambia lo stato PRIMA di questo
      // ripristino: senza, si rimetterebbe il title vecchio
      allineaRiduci();
    }
  }

  // Le voci col megamenu non hanno tooltip: a barra ridotta il nome lo porta
  // in testa il pannello delle sottocategorie.
  const voceConTip = (el) => {
    const voce = el.closest('.okko-nav__voce');
    return voce && !voce.hasAttribute('data-okko-mega-voce') ? voce : null;
  };

  document.addEventListener('mouseover', (e) => {
    // elementi "spiegati" ovunque nel sito (es. il ricarico nelle tabelle)
    const spiegato = e.target.closest('[data-okko-tip]');
    if (spiegato) { apriTip(spiegato, spiegato.dataset.okkoTip); return; }
    const voce = voceConTip(e.target);
    if (!voce || !ridotta()) return;
    mostraTip(voce);
  });
  document.addEventListener('mouseout', (e) => {
    if (e.target.closest('.okko-nav__voce') || e.target.closest('[data-okko-tip]')) nascondiTip();
  });
  // anche da tastiera; e via il tooltip appena qualcosa si muove sotto
  document.addEventListener('focusin', (e) => {
    const voce = voceConTip(e.target);
    if (voce && ridotta()) mostraTip(voce); else nascondiTip();
  });
  document.addEventListener('click', (e) => {
    const voce = voceConTip(e.target);
    if (voce && ridotta()) { mostraTip(voce); return; }
    nascondiTip();
  });
  window.addEventListener('scroll', nascondiTip, { passive: true });
  window.addEventListener('resize', nascondiTip);

  // --- Megamenu della sidebar ------------------------------------------------
  // Markup in okko-sidebar-menu.liquid: ramo = voce + freccina (mobile) +
  // pannello. Desktop: hover con ritardo (attraversare la sidebar non deve
  // accendere niente) e il click sulla voce naviga come sempre; il pannello e'
  // fixed accanto alla sidebar, anche a barra ridotta. Sugli schermi touch
  // larghi (tablet in orizzontale) l'hover non c'e': il primo tocco apre, il
  // secondo naviga. Mobile: fisarmonica, la apre e chiude solo la freccina.
  const MEGA_DESKTOP = window.matchMedia('(min-width: 901px)');
  const MEGA_HOVER = window.matchMedia('(hover: hover)');
  const MEGA_RITARDO_APRI = 150;
  const MEGA_RITARDO_CHIUDI = 250;
  let megaAperto = null; // il pannello aperto su desktop: uno alla volta
  let tMegaApri = 0;
  let tMegaChiudi = 0;

  const pannelloDi = (ramo) => ramo?.querySelector('[data-okko-mega]') || null;
  const megaHover = () => MEGA_DESKTOP.matches && MEGA_HOVER.matches;

  function segnaEspanso(pannello, aperto) {
    pannello.closest('[data-okko-mega-ramo]')
      ?.querySelectorAll(`[aria-controls="${pannello.id}"]`)
      .forEach((el) => el.setAttribute('aria-expanded', aperto ? 'true' : 'false'));
  }

  /** Accanto alla sidebar, con la testa all'altezza della voce, dentro lo schermo. */
  function posizionaMega(pannello) {
    const voce = pannello.closest('[data-okko-mega-ramo]')?.querySelector('[data-okko-mega-voce]');
    const nav = pannello.closest('.okko-nav');
    if (!voce || !nav) return;
    const sx = Math.round(nav.getBoundingClientRect().right + 8);
    pannello.style.left = `${sx}px`;
    pannello.style.maxWidth = `${window.innerWidth - sx - 16}px`;
    const testata = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--okko-testata-h')) || 56;
    let top = Math.round(voce.getBoundingClientRect().top - 14);
    top = Math.min(top, window.innerHeight - 8 - pannello.offsetHeight);
    pannello.style.top = `${Math.max(top, testata + 8)}px`;
  }

  function apriMega(pannello) {
    clearTimeout(tMegaApri);
    clearTimeout(tMegaChiudi);
    if (!pannello || megaAperto === pannello) return;
    if (megaAperto) chiudiMega(megaAperto);
    nascondiTip();
    pannello.classList.add('is-aperto');
    segnaEspanso(pannello, true);
    posizionaMega(pannello);
    megaAperto = pannello;
  }

  function chiudiMega(pannello = megaAperto) {
    if (!pannello) return;
    pannello.classList.remove('is-aperto');
    segnaEspanso(pannello, false);
    // via le coordinate desktop: su mobile lo stesso pannello e' una
    // fisarmonica in position:relative, e un left rimasto la spingerebbe
    // fuori dal drawer
    pannello.style.removeProperty('left');
    pannello.style.removeProperty('top');
    pannello.style.removeProperty('max-width');
    if (megaAperto === pannello) megaAperto = null;
  }

  document.addEventListener('mouseover', (e) => {
    if (!megaHover()) return;
    const ramo = e.target.closest('[data-okko-mega-ramo]');
    if (!ramo) return;
    const pannello = pannelloDi(ramo);
    if (pannello === megaAperto) {
      // rientrati nel ramo aperto (voce o pannello): niente chiusura, e niente
      // apertura della voce sfiorata in diagonale per arrivarci
      clearTimeout(tMegaChiudi);
      clearTimeout(tMegaApri);
      return;
    }
    if (!e.target.closest('[data-okko-mega-voce]')) return;
    clearTimeout(tMegaApri);
    tMegaApri = setTimeout(() => apriMega(pannello), MEGA_RITARDO_APRI);
  });

  document.addEventListener('mouseout', (e) => {
    if (!megaHover()) return;
    const ramo = e.target.closest('[data-okko-mega-ramo]');
    if (!ramo || ramo.contains(e.relatedTarget)) return;
    clearTimeout(tMegaApri);
    if (!megaAperto) return;
    clearTimeout(tMegaChiudi);
    tMegaChiudi = setTimeout(() => chiudiMega(), MEGA_RITARDO_CHIUDI);
  });

  // Tastiera: il fuoco visibile sulla voce apre, Tab entra nel pannello (che
  // nel DOM viene subito dopo), il fuoco fuori dal ramo chiude.
  let voceRiportata = null; // la voce a cui Esc riporta il fuoco: non riapre
  document.addEventListener('focusin', (e) => {
    if (!MEGA_DESKTOP.matches) return;
    const ramo = e.target.closest('[data-okko-mega-ramo]');
    if (ramo && pannelloDi(ramo) === megaAperto) { clearTimeout(tMegaChiudi); return; }
    const voce = e.target.closest('[data-okko-mega-voce]');
    if (voce && voce === voceRiportata) { voceRiportata = null; return; }
    if (voce?.matches(':focus-visible')) { apriMega(pannelloDi(ramo)); return; }
    if (megaAperto) chiudiMega();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape' || !megaAperto) return;
    const ramo = megaAperto.closest('[data-okko-mega-ramo]');
    const fuocoDentro = ramo?.contains(document.activeElement);
    chiudiMega();
    if (!fuocoDentro) return;
    voceRiportata = ramo.querySelector('[data-okko-mega-voce]');
    if (voceRiportata === document.activeElement) voceRiportata = null; // gia' li': nessun focusin in arrivo
    else voceRiportata?.focus();
  });

  document.addEventListener('click', (e) => {
    const espandi = e.target.closest('[data-okko-mega-espandi]');
    if (espandi) {
      const pannello = pannelloDi(espandi.closest('[data-okko-mega-ramo]'));
      if (pannello) segnaEspanso(pannello, pannello.classList.toggle('is-aperto'));
      return;
    }
    if (!MEGA_DESKTOP.matches) return;
    const ramo = e.target.closest('[data-okko-mega-ramo]');
    if (e.target.closest('[data-okko-mega-voce]') && !MEGA_HOVER.matches && pannelloDi(ramo) !== megaAperto) {
      e.preventDefault();
      apriMega(pannelloDi(ramo));
      return;
    }
    if (megaAperto && !(ramo && pannelloDi(ramo) === megaAperto)) chiudiMega();
  });

  // Il pannello e' agganciato alla voce in coordinate di schermo: se la
  // sidebar scorre o la finestra cambia misura si chiude invece di restare
  // sospeso nel punto sbagliato. Al cambio desktop/mobile si chiude tutto,
  // anche le fisarmoniche.
  document.addEventListener('scroll', (e) => {
    if (megaAperto && e.target instanceof Element && e.target.matches('.okko-nav__scroll')) chiudiMega();
  }, true);
  window.addEventListener('resize', () => chiudiMega());
  MEGA_DESKTOP.addEventListener('change', () => {
    document.querySelectorAll('[data-okko-mega].is-aperto').forEach((p) => chiudiMega(p));
  });

  // Editor del tema: selezionare la voce mostra il suo pannello
  document.addEventListener('shopify:block:select', (e) => {
    const voce = e.target.closest?.('[data-okko-mega-voce]');
    if (voce && MEGA_DESKTOP.matches) apriMega(pannelloDi(voce.closest('[data-okko-mega-ramo]')));
  });
  document.addEventListener('shopify:block:deselect', () => chiudiMega());

  // --- Strumento Omaggi / Promo ----------------------------------------------
  // La modale e' gia' scritta nel markup dal Liquid (il contenuto viene
  // dall'editor, non e' dinamico), quindi qui serve solo aprirla, chiuderla e
  // copiare il codice. Se il cliente e' escluso il dialog NON esiste affatto e
  // tutte queste funzioni non trovano niente da fare: nessun caso da gestire.
  const promoDlg = () => document.querySelector('dialog[data-okko-promo-modal]');

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-okko-promo-open]')) {
      const dlg = promoDlg();
      if (dlg && !dlg.open) dlg.showModal();
      return;
    }

    const dlg = promoDlg();
    if (!dlg || !dlg.open) return;

    // chiusura: la X, oppure il click sul velo (che sul <dialog> arriva come
    // click sull'elemento stesso, non su un figlio)
    if (e.target === dlg || e.target.closest('[data-okko-promo-chiudi]')) {
      dlg.close();
      return;
    }

    const copia = e.target.closest('[data-okko-promo-copia]');
    if (copia) {
      const codice = dlg.querySelector('[data-okko-promo-codice]')?.textContent.trim();
      if (!codice) return;
      // navigator.clipboard vuole HTTPS e il permesso: se manca si ripiega
      // sulla selezione, cosi' il codice si copia comunque a mano con Cmd+C
      const fatto = () => {
        const prima = copia.textContent;
        copia.textContent = copia.dataset.okkoCopiato || 'Copiato';
        copia.classList.add('is-copiato');
        setTimeout(() => { copia.textContent = prima; copia.classList.remove('is-copiato'); }, 2000);
      };
      if (navigator.clipboard?.writeText) {
        navigator.clipboard.writeText(codice).then(fatto).catch(() => selezionaCodice(dlg));
      } else {
        selezionaCodice(dlg);
      }
    }
  });

  function selezionaCodice(dlg) {
    const el = dlg.querySelector('[data-okko-promo-codice]');
    if (!el) return;
    const r = document.createRange();
    r.selectNodeContents(el);
    const sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(r);
  }

  document.addEventListener('shopify:section:deselect', (e) => {
    const dlg = e.target.querySelector('dialog[open]');
    if (dlg) dlg.close();
  });
})();
